import AppRoutes from '@/app/routes/AppRoutes';
import { getLanguage, setLanguage } from '@/shared/i18n';
import TranslateIcon from '@mui/icons-material/Translate';
import { FloatingBubble } from 'antd-mobile';
import React from 'react';

function handleToggleLanguage() {
  const next = getLanguage() === 'ja' ? 'en' : 'ja';
  setLanguage(next);
}

export default function App() {
  const env = import.meta.env.VITE_FIREBASE_ENV;

  return (
    <>
      <AppRoutes />
      {env === 'development' && (
        <FloatingBubble
          style={{
            '--initial-position-bottom': '24px',
            '--initial-position-right': '24px',
            '--edge-distance': '24px',
          }}
          onClick={handleToggleLanguage}
        >
          <TranslateIcon />
        </FloatingBubble>
      )}
    </>
  );
}
